
import {useMutation} from 'react-query';
import {getChat} from '.';

interface UseGetChatProps {
  onSuccess?: (data: any) => void;
  onError?: (error: any) => void;
}

const useGetChat = ({onSuccess, onError}: UseGetChatProps = {}) => {
  const {mutate, data, isLoading} = useMutation({
    mutationFn: (params: string) => getChat(params),
    onSuccess,
    onError,
  });

  return {
    getChat: mutate,
    data,
    isLoading, 
  };
};

export default useGetChat;
